import { Box, createTheme, Divider, Grid, Paper, Table, TableBody, TableCell, Checkbox, TableContainer, TableHead, TableRow, Typography, Button, FormControl, InputLabel, Select, MenuItem, ListItemText, TextField, LinearProgress } from '@material-ui/core';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import { method, noop } from 'lodash';
import React from 'react';
import { useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { title } from 'process';
import { useUsers } from '../../../common/CommonQueries';
import { useDeliverables } from '../../projectManagementQueries';
import { useErrorHandlingContext } from '../../../common/ErrorHandlingContext';
import { useCustomerDetailsContext } from '../../../common/CustomerDetailsContext';
import CoverPage from './coverPage';
import { useDeliverableForm } from '../../projectManagementMutations';
import { useFetchContext } from '../../../common/FetchContext';
import { toast } from 'react-toastify';
import DeliverablesData from './DeliverablesData';
import { getBaseUrlProd } from '../../../common/util';
const DeliverablesTitle = () => {

    const location = useLocation();

    const passedData = location.state as { tests: string };
    const { authAxios } = useFetchContext();

    const { workOrderId } = useParams() as { workOrderId : string };
    


    console.log(passedData.tests);
    const [formData, setFormData] = useState({
        title:null,
        customer: null,
        contactName: null,
        contactEmail: null,
        projectNo:null,
        revision: null,
        status: null,
        date: new Date().toISOString(),
        classification: null,
        author: null,
        checked: null,
        approved: null,
        providedBy: null,
    });
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [formCompleted, setFormCompleted] = useState(false);
    // const { mutateAsync: mutate } = useCreateForm();
    // const { mutateAsync: mutateUpdate } = useUpdateForm();

    const { mutateAsync: mutate } = useDeliverableForm();

     const { state: stateError, dispatch: dispatchError } =
       useErrorHandlingContext();
      const { state } = useCustomerDetailsContext();


    const rows = [
        { id: 1, revision: "1.0", date: "26/12/2024", summary: "Initial draft" },
        { id: 2, revision: "1.1", date: "27/12/2024", summary: "Minor updates" },
        { id: 3, revision: "2.0", date: "28/12/2024", summary: "Major revision" },
    ];

    const openDeliverables = async () => {

        try {
                
            if(projects){
                await mutate({
                    authAxios,
                    method:"PATCH",
                    title: formData.title?formData.title:projects.title,
                    contact_name: formData.contactName?formData.contactName:projects.title,
                    contact_email: formData.contactEmail?formData.contactEmail:projects.contact_email,
                    revision: formData.revision?formData.revision:projects.rvision,
                    status: formData.status?formData.status:projects.status,
                    date: formData.date?formData.date:projects.date,
                    classification: formData.classification?formData.classification:projects.classification,
                    author: formData.author?formData.author:projects.author,
                    checked: formData.checked?formData.checked:projects.checked,
                    approved: formData.approved?formData.approved:projects.approved,
                    provided_by: formData.providedBy?formData.providedBy:projects.provided_by,
                    workorder_id:workOrderId+'',
                  });
            }else{
                await mutate({
                    authAxios,
                    method:"POST",
                    title: formData.title,
                    customer: projects?projects.customer:state.activeCustomerUrl,
                    contact_name: formData.contactName,
                    contact_email: formData.contactEmail,
                    project:projects?projects.project:state.activeProjectUrl,
                    workorder: projects?projects.workorder:`${getBaseUrlProd()}work_orders/${workOrderId}/`,
                    revision: formData.revision,
                    status: formData.status,
                    date: formData.date,
                    classification: formData.classification,
                    author: formData.author,
                    checked: formData.checked,
                    approved: formData.approved,
                    provided_by: formData.providedBy,
                    workorder_id:workOrderId+'',
                  });
            }


            
              
            

            // const newDelivarablesData = await mutateUpdate({
            //     title: projects?projects.title:formData.title,
            //     customer: projects?projects.customer:state.activeCustomerUrl,
            //     contact_name: projects?projects.contact_name:formData.contactName,
            //     contact_email: projects?projects.contact_email:formData.contactEmail,
            //     project:projects?projects.project:state.activeProjectUrl,
            //     workorder: projects?projects.workorder:`https://lsdbhaveblueuat.azurewebsites.net/api/1.0/work_orders/${state.activeWorkOrder}/`,
            //     revision: formData.revision,
            //     status: formData.status,
            //     date: formData.date,
            //     classification: formData.classification,
            //     author: projects?projects.author:formData.author,
            //     checked: projects?projects.checked:formData.checked,
            //     approved: projects?projects.approved:formData.approved,
            //     provided_by: projects?projects.provided_by:formData.providedBy,
            //     workorder_id:state.activeWorkOrder+'',

            // })
        
            setFormCompleted(true);

            
            
    } catch (error) {
      toast.error("An error occurred. Please try again."+error.message);
        
    }
    // history.push(`/project_management/customer/projects/work_orders/deliverabledata`);
};
const [selectedTests, setSelectedTests] = useState<number[]>([]);
const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedTests(event.target.value as number[]);
};
const handleChangeField = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
};

const {
    error: errorProjectManagers,
    data: projectManagers,
    isError: isErrorProjectManagers,
} = useUsers();


const {
    error: errorProjects,
    data: projects,
    isLoading: isLoadingProjects,
    isError: isErrorProjects,
} = useDeliverables(workOrderId+'');



if (isLoadingProjects) {
    return (
        <LinearProgress />
    )
}

return (
    <>
        {formCompleted ?
           <DeliverablesData work_order={workOrderId+""} procedure_definistion={passedData.tests}></DeliverablesData>

            :
            <>
                {/* <Grid container spacing={1}>
                {Object.keys(formData).map((key) => (
                    
                    <React.Fragment key={key}>
                        <Grid item xs={6}>
                            <TextField
                                label={key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                name={key}
                                value={formData[key as keyof typeof formData]}
                                onChange={handleChangeField}
                                fullWidth
                                multiline={key === "providedBy"}
                                rows={key === "providedBy" ? 4 : 1}
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid> */}

                <Grid container spacing={1}>
                    {Object.keys(formData).map((key) => {
                        const label = key
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^./, (str) => str.toUpperCase());
                        const value = formData[key as keyof typeof formData];
                        return (
                            <React.Fragment key={key}>
                                <Grid item xs={6}>
                                    {(() => {
                                        switch (key) {
                                            case "title":
                                                return (
                                                    <TextField
                                                        id="title"
                                                        type="text"
                                                        label={label}
                                                        name={key}
                                                        value={projects?projects.title:''}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        multiline
                                                        rows={1}
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                );
                                            case "customer":
                                                return (
                                                    <TextField
                                                        id="customer"
                                                        label={label}
                                                        name={key}
                                                        value={projects?projects.customer_name:state.customer_name}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        multiline
                                                        rows={1}
                                                        variant="outlined"
                                                        size="small"
                                                        disabled
                                                    />
                                                );
                                                case "contactName":
                                                return (
                                                    <TextField
                                                        id="contactName"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects&&projects.contact_name}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        multiline
                                                        rows={1}
                                                        variant="outlined"
                                                        size="small"
                                                       
                                                    />
                                                );
                                            
                                            case "contactEmail":
                                                return (
                                                    <TextField
                                                        id="contactEmail"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects&&projects.contact_email}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        multiline
                                                        rows={1}
                                                        variant="outlined"
                                                        size="small"
                                                        
                                                    />
                                                );
                                            case "projectNo":
                                                return (
                                                    <TextField
                                                        id="projectNo"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects?projects.project_number:state.activeProjectId}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        multiline
                                                        rows={1}
                                                        variant="outlined"
                                                        size="small"
                                                        disabled
                                                    />
                                                );
                                            case "revision":
                                                return (
                                                    <TextField
                                                        id="revision"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects&&projects.revision}
                                                        onChange={handleChangeField}
                                                        select
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        {["Initial", "Verified", "Approved"].map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                );
                                            case "status":
                                                return (
                                                    <TextField
                                                        id="status"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects&&projects.status}
                                                        onChange={handleChangeField}
                                                        select
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        {["Initial", "Verified", "Approved"].map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                );
                                            case "date":
                                                return (
                                                    <TextField
                                                        id="date"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects&&projects.date}
                                                        onChange={handleChangeField}
                                                        type="datetime-local"
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                );
                                            case "classification":
                                                return (
                                                    <TextField
                                                        id="classification"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects&&projects.classification}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        multiline
                                                        rows={1}
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                );
                                            case "author":
                                                return (
                                                    <TextField
                                                        id="author"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value : projects&&projects.author}
                                                        onChange={handleChangeField}
                                                        select
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        {projectManagers?.map((projectManager: any) => (
                                                            <MenuItem
                                                                key={projectManager.id}
                                                                value={projectManager.url}>
                                                                {projectManager.first_name}{" "}
                                                                {projectManager.last_name}

                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                );
                                            case "checked":
                                                return (
                                                    <TextField
                                                        id="checked"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value : projects&&projects.checked}
                                                        onChange={handleChangeField}
                                                        select
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        {projectManagers?.map((projectManager: any) => (
                                                            <MenuItem
                                                                key={projectManager.id}
                                                                value={projectManager.url}>
                                                                {projectManager.first_name}{" "}
                                                                {projectManager.last_name}

                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                );
                                            case "approved":
                                                return (
                                                    <TextField
                                                        id="approved"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value : projects&&projects.approved}
                                                        onChange={handleChangeField}
                                                        select
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        {projectManagers?.map((projectManager: any) => (
                                                            <MenuItem
                                                                key={projectManager.id}
                                                                value={projectManager.url}>
                                                                {projectManager.first_name}{" "}
                                                                {projectManager.last_name}

                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                );
                                            case "providedBy":
                                                return (
                                                    <TextField
                                                        id="providedBy"
                                                        label={label}
                                                        name={key}
                                                        value={value ? value :projects&&projects.provided_by}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        multiline
                                                        rows={4}
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                );
                                            default:
                                                return (
                                                    <TextField
                                                        label={label}
                                                        name={key}
                                                        value={value}
                                                        onChange={handleChangeField}
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                );
                                        }
                                    })()}
                                </Grid>
                            </React.Fragment>
                        );
                    })}
                </Grid>


                <Box display="flex" justifyContent="center" style={{ margin: '5px', flexDirection: 'row' }}>
                    <Button variant="contained" style={{ backgroundColor: 'orange', color: 'black', margin: '0 5px' }} onClick={openDeliverables}>
                        NEXT
                    </Button>

                </Box>
            </>
        }
    </>
)
}
export default DeliverablesTitle




